import React from "react";
import { ModalTemplate } from "../modal-template/modal-template.component";
import { ModalContent, Text } from "../delete-confirmation-modal/delete-confirmation-modal.styles";
import { SideBySide } from "../../side-by-side/side-by-side.component";
import { OutlinedButton } from "../../form-controls/button/outlined-button/outlined-button.component";
import { GreenButton } from "../../form-controls/button/green-button/green-button.component";
import { ConfirmationModalProps } from "./confirmation-modal.props";

export const ConfirmationModal = (props: ConfirmationModalProps) => (
  <ModalTemplate header={props.title} open={props.isOpen} size="medium" closeModal={props.onCancel}>
    <ModalContent>
      <Text>{props.children}</Text>
      <SideBySide>
        <OutlinedButton onClick={props.onCancel}>Cancel</OutlinedButton>
        <GreenButton onClick={props.onConfirm}>Confirm</GreenButton>
      </SideBySide>
    </ModalContent>
  </ModalTemplate>
);
